import { useState, useRef, useEffect } from "react";
import './filters.css'
import { Filter } from "lucide-react";
import TableFilter from "./TableFilter";

const useToggleDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return { isOpen, toggleDropdown, ref };
};



const FiltersComponent = ({ setFilters, setSearchQuery, filtersConfig, handleSave, handleCancel, filters, timeFilter }) => {
  const { isOpen, toggleDropdown, ref } = useToggleDropdown();

  return (
    <div className="position-relative" ref={ref}>
      <button className="filters_button" style={{ backgroundColor: "#1e67d6", color:'#fff' }} onClick={toggleDropdown}>
        <div className="d-flex justify-content-center align-items-center gap-2">
        <span style={{fontSize:'16px'}}> <b>Filters</b></span> <Filter className="" size={18} /> 
        </div>
      </button>
      {isOpen && (
        <TableFilter
          setFilters={setFilters}
          timeFilter={timeFilter}
          setSearchQuery={setSearchQuery}
          filtersConfig={filtersConfig}
          handleSave={handleSave}
          handleCancel={handleCancel}
          filters={filters}
        />
      )}
    </div>
  );
};

export default FiltersComponent;
